module.exports = __webpack_public_path__ + "static/media/cta-illustr.2f1370fe.png";